import React, { Fragment, useMemo } from 'react';
import { RoundStatus } from '@pascal/pascal-core';
import ImgBall from '../../../../../assets/images/img-ball.png';

const GameLatestResults = ({ data = [] }) => {
  const updatedResult = useMemo(() => {
    return data.filter((item) => item.status === RoundStatus.Finished).splice(0, 10);
  }, [data]);

  return (
    <div className='v-block-coef-row-ins'>
      {updatedResult.length ? (
        updatedResult?.map((result) => {
          const bgColorClassName =
            +result?.roundData?.odd <= 1
              ? 'red'
              : +result?.roundData?.odd > 1 && +result?.roundData?.odd <= 3
              ? 'green'
              : result?.roundData?.odd > 3 && +result?.roundData?.odd <= 10
              ? 'orange'
              : 'purple';

          return (
            <Fragment key={result.roundId}>
              {result?.roundData?.odd ? (
                <div className='v-block-coef-block-wrp' title={result.roundData.odd}>
                  <div className={`v-block-coef-block ${bgColorClassName}`}>
                    <div className='v-block-coef-block-img'>
                      <img src={ImgBall} alt='' />
                    </div>
                    <p className='v-block-coef-block-txt'>x{result?.roundData?.odd}</p>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </Fragment>
          );
        })
      ) : (
        <></>
      )}
    </div>
  );
};

export default GameLatestResults;
